import { render, staticRenderFns } from "./DotInformation.vue?vue&type=template&id=6a8286c7&scoped=true&"
import script from "./DotInformation.vue?vue&type=script&lang=js&"
export * from "./DotInformation.vue?vue&type=script&lang=js&"
import style0 from "./DotInformation.vue?vue&type=style&index=0&id=6a8286c7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8286c7",
  null
  
)

export default component.exports